import React from 'react';
import { FeedbackModalInternal } from './FeedbackModalInternal';
import { defaultFeedback } from '../locales/Locale';
import { LocaleContext } from '../context/LocaleContext';
;
/**
 * Creates an instance of the feedback modal.
 *
 * @param props
 * @returns
 */
export const FeedbackModal = (props) => React.createElement(LocaleContext.Provider, { value: props.feedbackLocale ? props.feedbackLocale : defaultFeedback },
    React.createElement(FeedbackModalInternal, Object.assign({}, props)));
export default FeedbackModal;
